export enum AggregationEngine {
  NONLINEAR = 'Non-Linear',
  LINEAR = 'Linear',
  CALCULATED = 'Backend',
  STATIC = 'Static',
}

export enum GroupName {
  ASSET = 'Asset',
  TRANSITIVE = 'Transitive',
  HISTORICAL = 'Historical',
  EXPOSURE = 'Exposure',
  VaR = 'VaR',
  SENSITIVITY = 'Sensitivity',
  LADDER = 'Ladder',
}

export enum FxFormulaConstants {
  NO_CONVERSION = '0 - No Conversion',
  DIRECT_CONVERSION = '1 - Direct Conversion',
  FX_DELTAS = '2 - FX Deltas',
  FX_STRESS_TEST = '3 - FX Stress Test',
  FX_VOL_STRESS_TEST = '4 - FX Vol Stress Test',
  FX_USD_CCY_STRESS_TEST = '5 - FX usdCCY Stress Test',
}

export enum UnitConstants {
  REPORT_CCY = 'Report ccy',
  HOLDING_CCY = 'Holding ccy',
  PERCENTAGE = '%',
  DATE = 'Date',
  TIMESTAMP = 'Timestamp',
  TEXT = 'Text',
  NUMERIC = 'Numeric',
}

export enum ExcelTabNameConstants {
  PORTFOLIO_SUMMARY = 'Portfolio Summary',
  ASSET = 'Asset',
}
